<script setup lang="ts">
import { AppButton, AppSlideUpAndDownTransition } from '@libs/ui';

import { useGlobalCurrencyStore } from '../../../../core/stores/globalCurrencyStore';
import { useTripSummaryStore } from '../../stores';

const tripSummaryStore = useTripSummaryStore();
const globalCurrencyStore = useGlobalCurrencyStore();

interface TripPriceSummaryFooterMobileEmits {
  (eventName: 'show-summary-clicked'): void;
}

const emits = defineEmits<TripPriceSummaryFooterMobileEmits>();
</script>

<template>
  <AppSlideUpAndDownTransition>
    <div class="trip-price-summary-footer-mobile">
      <div class="total-price">
        <div class="text">{{ $t('planner.total_price_for_trip') }}</div>
        <div class="amount">
          {{
            globalCurrencyStore.formatMoney(
              tripSummaryStore.tripTotalPrice +
                tripSummaryStore.tripTotalAddonsPrice
            )
          }}
        </div>
      </div>

      <div>
        <AppButton
          type="important"
          size="medium"
          :state="tripSummaryStore.bookingButtonState"
          @click="emits('show-summary-clicked')"
        >
          {{ $t('planner.show_summary') }}
        </AppButton>
      </div>
    </div>
  </AppSlideUpAndDownTransition>
</template>

<style scoped lang="scss">
.trip-price-summary-footer-mobile {
  width: 100vw;

  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--spacing-16);
  border-top: 1px solid var(--color-neutral-30);

  .total-price {
    color: var(--color-neutral-70);
    display: flex;
    flex-direction: column;

    .text {
      @include font-label-s-light;
    }

    .amount {
      @include font-heading-5;
    }
  }
}
</style>
